import { render } from "./WelcomeDialog.vue?vue&type=template&id=773d2aad"
import script from "./WelcomeDialog.vue?vue&type=script&lang=js"
export * from "./WelcomeDialog.vue?vue&type=script&lang=js"

import "./WelcomeDialog.vue?vue&type=style&index=0&id=773d2aad&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__